// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__RAaPJ","signatureButtonsRight":"ModalSign_signatureButtonsRight__25tvK"};